<div class="container-fluid mt-3">
  <h3>File Scans</h3>

  <div class="row">
    <div class="col-md-4">
      <div class="list-group">
        @for (scan of scans; track scan.scanUid) {
          <button
            type="button"
            class="list-group-item list-group-item-action"
            [class.active]="selectedScanUid === scan.scanUid"
            (click)="selectScan(scan.scanUid)"
          >
            <div class="d-flex w-100 justify-content-between">
              <h6 class="mb-1">{{ scan.stracliHost }}</h6>
              <small>{{ scan.scanLastReceivedTime | date:'yyyy-MM-dd HH:mm:ss' }}</small>
            </div>
            <small class="text-muted">{{ scan.initialDir }}</small>
          </button>
        }
      </div>
    </div>

    <div class="col-md-8">
      @if (selectedScanUid) {
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span>Scan Details: {{ selectedScanUid }}</span>
            @if (loadingRoot) {
              <span class="badge badge-info">Loading root...</span>
            }
          </div>
          <div class="card-body p-0">
            <div class="file-table-header d-flex bg-light border-bottom p-2 font-weight-bold">
              <div class="header-cell name sortable" (click)="toggleSort('path')">
                Path
                @if (sortConfig.column === 'path') {
                  <span class="sort-indicator">{{ sortConfig.direction === 'asc' ? '▲' : '▼' }}</span>
                }
              </div>
              <div class="header-cell size sortable" (click)="toggleSort('size')">
                Size
                @if (sortConfig.column === 'size') {
                  <span class="sort-indicator">{{ sortConfig.direction === 'asc' ? '▲' : '▼' }}</span>
                }
              </div>
              <div class="header-cell relative">
                Rel.
              </div>
              <div class="header-cell date sortable" (click)="toggleSort('modifiedAt')">
                Modified
                @if (sortConfig.column === 'modifiedAt') {
                  <span class="sort-indicator">{{ sortConfig.direction === 'asc' ? '▲' : '▼' }}</span>
                }
              </div>
            </div>
            <div class="file-tree-container">
              @for (file of rootFiles; track file.id) {
                <app-file-scan-item
                  [scanUid]="selectedScanUid"
                  [item]="file"
                  [sortConfig]="sortConfig"
                ></app-file-scan-item>
              }
            </div>
            @if (!loadingRoot && rootFiles.length === 0) {
              <div class="p-3 text-center text-muted">
                No files found for this scan.
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="alert alert-info">
          Please select a scan from the list to view its contents.
        </div>
      }
    </div>
  </div>
</div>
